export enum SupportedCountries {
    JP = 'JP',
    SG = 'SG',
    KR = 'KR',
    CH = 'CH',
    AU = 'AU',
    IN = 'IN',
}
